// @ts-ignore
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { HttpService } from '../../../../core';

@Component({
  selector: 'app-properties',
  templateUrl: './properties.component.html',
  styleUrls: ['./properties.component.scss']
})

export class PropertiesComponent implements OnInit {
  @Input() project: any;
  @Input() isPackageProperty: boolean;
  @Output() closeDialog = new EventEmitter();
  mode: any;
  // properties = []

  constructor(private httpService: HttpService) {
  }

  ngOnInit(): void {
    this.mode = 'manage';
    console.log(this.project);
    // this.httpService.getAllPropertiesByProjectId(this.project.id).subscribe((res: any) => {
    //   console.log(res);
    //   this.properties = res.data;
    // });
  }

  changeMode(event) {
    console.log(event);
    this.mode = event.value;
    if (event.value === 'manage') {
      // this.httpService.getAllPropertiesByProjectId(this.project.id).subscribe((res: any) => {
      //   console.log(res);
      //   this.properties = res.data;
      // });
    }
  }

  addNewProperty(event) {
    console.log(event);
    if (this.project.properties) {
      this.project.properties.push(event.newProperty);
    } else {
      this.project.properties = [event.newProperty];
    }
  }

  receiveSignal(e) {
    if (e.value) {
      this.closeDialog.emit({ value: true });

    }
  }

}
